import type { PendingScan } from '@/db/models';
import { Pill } from '@/shared/components/Pill';
import '@/features/leads/components/LeadListItem.css';

const RATING_TONE = { Hot: 'hot', Warm: 'warm', Cold: 'cold' } as const;

/**
 * Deliberately not clickable (unlike LeadListItem) -- there's no server
 * scanId to navigate to yet, so notes/rating editing for a not-yet-synced
 * scan isn't available until it uploads. It still shows what WAS captured
 * (rating/notes set at scan time via manual entry) so the exhibitor has
 * confidence the capture worked while offline.
 */
export function PendingLeadItem({ scan }: { scan: PendingScan }) {
  const scannedAt = new Date(scan.scannedAtUtc);

  return (
    <div className="lead-item" style={{ cursor: 'default', opacity: 0.85 }}>
      <div className="lead-item__main">
        <span className="lead-item__name">Awaiting sync</span>
        <span className="lead-item__badge font-mono">{truncate(scan.scannedValue)}</span>
      </div>

      <div className="lead-item__side">
        <Pill tone="offline">Pending sync</Pill>
        {scan.rating && <Pill tone={RATING_TONE[scan.rating]}>{scan.rating}</Pill>}
        <time className="lead-item__time" dateTime={scan.scannedAtUtc}>
          {scannedAt.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
        </time>
      </div>
    </div>
  );
}

function truncate(value: string): string {
  return value.length > 24 ? `${value.slice(0, 21)}…` : value;
}
